module.exports = __webpack_public_path__ + "img/V52.bd1a352e.jpg";